module.exports = __webpack_public_path__ + "img/f29.fe80a4c4.jpg";